import { Map, Marker } from '@vis.gl/react-google-maps';
import { StyleSheet, View } from 'react-native';

import Text from '@/components/Text';
import { i18n } from '@/utils/i18n';

import { MapComponentProps } from './MapComponent';

const WebMap = ({
  lat,
  lng,
  title,
  onPressMarker
}: {
  lat: number;
  lng: number;
  title: string;
  onPressMarker: () => void;
}) => (
  <Map style={styles.map} defaultZoom={10} defaultCenter={{ lat, lng }}>
    <Marker position={{ lat, lng }} title={title} onClick={onPressMarker} />
  </Map>
);

const MapComponent = ({ markerCoordinates, markerTitle }: MapComponentProps) => {
  const markerLatitude = markerCoordinates?.at(0) ?? 0;
  const markerLongitude = markerCoordinates?.at(1) ?? 0;

  const openGoogleMaps = () => {
    const encodedLabel = encodeURIComponent(markerTitle);
    const url = `https://www.google.com/maps/place/${encodedLabel}/@${markerLatitude},${markerLongitude},17z`;
    window.open(url, '_blank');
  };

  return (
    <View style={styles.mapContainer}>
      {markerCoordinates && markerCoordinates.length > 0 ? (
        <WebMap lat={markerLatitude} lng={markerLongitude} title={markerTitle} onPressMarker={openGoogleMaps} />
      ) : (
        <Text> {i18n.t('mix.n_a')}</Text>
      )}
    </View>
  );
};

export default MapComponent;

const styles = StyleSheet.create({
  flexOne: {
    flex: 1
  },

  titleContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },

  titleText: {
    fontSize: 22
  },

  mapContainer: {
    justifyContent: 'center',
    alignItems: 'center'
  },

  map: {
    width: '100%',
    height: 350
  }
});
